import Link from "next/link";
import { InputHTMLAttributes } from "react";

interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  link?: string;
}

const Checkbox: React.FC<CheckboxProps> = ({ label, link, className, ...props }) => {
  return (
    <div className="flex items-center">
      <label className={`inline-flex items-center gap-3 ${className}`}>
        <input
          type="checkbox"
          className="h-5 w-5 rounded border-gray-400 text-secondary transition duration-150 ease-in-out focus:ring-secondary"
          {...props}
        />
        <span className="text-dark-1 text-opacity-80">{link ? <Link href={link}>{label}</Link>  : label}</span>
      </label>
    </div>
  );
};

export default Checkbox;
